import request from "./request.js"

/****首页接口****/
export const getRequestHomeStatisticsData = () => request({
	url: '/api/v1/home-statistics/',
	method: 'get',
	silentBusinessError: true,
})

/****新闻页面接口****/
export const getRequestNewsListData = page => request({url: `/api/v1/news?page=${page}`, method: 'get'})
export const getRequestNewsDetailsData = id => request({url: `/api/v1/news/${id}`, method: 'get'})
export const getRequestNewsDetailsNextData = id => request({url: `/api/v1/news/${id}/prev-next/`, method: 'get'})

/****联系我们接口****/
export const postRequestContactUsData = data => request({method: 'post', url: `/api/v1/contact-us/`, data});

/****AI咨询接口****/
export const postRequestAiConsultData = data => request({method: 'post', url: `/api/v1/ai/consult/`, data});

const AI_QA_API_PREFIX = '/copilot/v1'

export const postRequestAiLeadData = async data => {
	const response = await fetch(`${AI_QA_API_PREFIX}/lead`, {
		method: 'POST',
		headers: {'Content-Type': 'application/json'},
		body: JSON.stringify(data),
	})
	const result = await response.json().catch(() => null)
	if (!response.ok) {
		const error = new Error(result?.message || '提交失败，请稍后重试')
		error.status = response.status
		throw error
	}
	return result
}

export const getRequestAiSuggestionsData = async () => {
	const response = await fetch(`${AI_QA_API_PREFIX}/suggestions`)
	if (!response.ok) {
		throw new Error(`推荐问题请求失败（${response.status}）`)
	}
	return response.json()
}

export const postRequestAiFeedbackData = async ({
	question,
	rating,
	sessionId,
	comment = '',
}) => {
	const response = await fetch(`${AI_QA_API_PREFIX}/feedback`, {
		method: 'POST',
		headers: {'Content-Type': 'application/json'},
		body: JSON.stringify({
			question,
			rating,
			...(sessionId ? {session_id: sessionId} : {}),
			...(comment ? {comment} : {}),
		}),
	})

	const data = await response.json().catch(() => null)
	if (!response.ok) {
		const error = new Error(data?.message || '反馈提交失败，请稍后重试')
		error.status = response.status
		throw error
	}
	return data
}

export const postRequestAiQaStreamData = async ({
	question,
	sessionId,
	fromFollowup = false,
	signal,
	onStep,
	onEvidence,
	onChart,
	onToken,
	onFollowups,
	onBlocked,
	onFinal,
	onError,
}) => {
	const response = await fetch(`${AI_QA_API_PREFIX}/chat`, {
		method: 'POST',
		headers: {'Content-Type': 'application/json'},
		body: JSON.stringify({
			question,
			...(sessionId ? {session_id: sessionId} : {}),
			...(fromFollowup ? {from_followup: true} : {}),
		}),
		signal,
	})

	if (!response.ok) {
		const data = await response.json().catch(() => null)
		onError?.(data?.message || `AI咨询请求失败（${response.status}）`)
		return
	}

	const contentType = response.headers.get('Content-Type') || ''
	if (!contentType.includes('text/event-stream') || !response.body) {
		const data = await response.json().catch(() => null)
		onError?.(data?.message || 'AI咨询服务返回格式异常')
		return
	}

	const reader = response.body.getReader()
	const decoder = new TextDecoder()
	let buffer = ''
	let terminated = false

	const handleEventPart = part => {
		if (terminated) return
		const dataLines = part
			.split(/\r?\n/)
			.filter(line => line.startsWith('data:'))
			.map(line => line.slice(5).trim())
		if (!dataLines.length) {
			return
		}

		let payload
		try {
			payload = JSON.parse(dataLines.join('\n'))
		} catch {
			return
		}

		switch (payload?.type) {
			case 'step':
				onStep?.(payload)
				break
			case 'evidence':
				onEvidence?.(payload)
				break
			case 'chart':
				onChart?.(payload)
				break
			case 'token':
				onToken?.(payload.text || '')
				break
			case 'followups':
				onFollowups?.(payload.questions)
				break
			case 'blocked':
				onBlocked?.(payload.message || '')
				break
			case 'final':
				terminated = true
				onFinal?.(payload)
				break
			case 'error':
				terminated = true
				onError?.(payload.message || 'AI咨询服务暂时不可用')
				break
		}
	}

	while (!terminated) {
		const {value, done} = await reader.read()
		if (done) {
			break
		}

		buffer += decoder.decode(value, {stream: true})
		const parts = buffer.split(/\r?\n\r?\n/)
		buffer = parts.pop() || ''

		for (const part of parts) {
			handleEventPart(part)
		}
	}

	if (buffer.trim()) {
		handleEventPart(buffer)
	}

	if (!terminated) {
		onError?.('AI咨询连接已中断，请稍后重试')
	}
}

/****技术服务平台接口****/
export const getRequestPlatformListData = () => request({url: `/api/v1/platforms/`, method: 'get'}) // 获取平台列表
export const getRequestArticlesDetailsData = id => request({url: `/api/v1/articles/${id}/`, method: 'get'}) // 获取文章详情
export const getRequestPlatformBannerData = name => request({url: `/api/v1/platforms/${name}/banner/`, method: 'get'}) // 获取平台banner

/****获取平台菜单****/
export const getRequestPlatformCategoriesData = name => request({  //获取文章列表
	url: `/api/v1/platforms/${name}/categories/`, method: 'get'
})

export const getRequestPlatformArticlesListData = (platform, categories = null, page = null) => {
	// 构建请求参数对象
	const params = {platform};
	// 如果有 categories，则将其添加到请求参数
	if (categories !== null) {
		params.categories = categories;
	}
	// 如果有 page，则将其添加到请求参数
	if (page !== null) {
		params.page = page;
	}
	// 发送 GET 请求
	return request({
		url: '/api/v1/articles/',
		method: 'get',
		params: params,
	});
}

export const getRequestArticlesDetailsNextData = (platform, categories = null, id) => {
	// 构建请求参数对象
	const params = {platform};
	// 如果有 categories，则将其添加到请求参数
	if (categories !== null) {
		params.categories = categories;
	}
	return request({
		url: `/api/v1/articles/${id}/prev-next/`,
		method: 'get',
		params: params,
	});
}

/****视频平台接口****/
export const getRequestVideosListData = () => request({url: '/api/v1/videos/', method: 'get'})
export const getRequestVideoDetailsData = id => request({url: `/api/v1/videos/${id}/`, method: 'get'})
export const getRequestVideoDetailsNextData = id => request({url: `/api/v1/videos/${id}/prev-next/`, method: 'get'})

/****搜索接口****/
export const getRequestSearchData = (q, page) => request({
	url: `/api/v1/search/`, method: 'get', params: {
		q: q, page: page
	}
})

/****专题接口****/
export const getRequestTopicListData = () => request({url: '/api/v1/special-subjects/', method: 'get'})
export const getRequestTopicGroupListData = () => request({url: '/api/v1/special-subjects/grouped/', method: 'get'})
export const getRequestTopicCategoriesData = name => request({  //获取文章列表
	url: `/api/v1/special-subjects/${name}/categories/`, method: 'get'
})
export const getRequestTopicArticlesListData = (special_subject, categories, page) => request({  //获取文章列表
	url: '/api/v1/articles/', method: 'get', params: {
		special_subject: special_subject, categories: categories, page: page
	}
})
export const getRequestTopicBannerData = name => request({url: `/api/v1/special-subjects/${name}/`, method: 'get'})

export const getRequestTopicArticlesDetailsNextData = (special_subject, categories, id) => request({  //获取文章下一篇详情
	url: `/api/v1/articles/${id}/prev-next/`, method: 'get', params: {
		special_subject: special_subject, categories: categories
	}
})

export const getRequestCenterLabListData = () => request({url: `/api/v1/tabs/central_laboratory/`, method: 'get'})
export const getRequestCenterIntroData = () => request({url: `/api/v1/platforms/central_laboratory/introduction/`, method: 'get'})
